/*
 * Author: Roger
 * File Created: Monday, 24-10-14 10:59 pm
 * Last Modified: Monday, 24-10-14 11:00 pm, by Roger
 */

const TinyCube = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" fill="none" data-sentry-element="svg" data-sentry-component="TinyCube" data-sentry-source-file="index.tsx">
      <rect width="5.77287" height="5.8555" transform="matrix(0.866756 0.498732 -0.866756 0.498732 5.10864 0.015625)" fill="#C09CFC" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      <rect opacity="0.76" width="4.65259" height="5.7773" transform="matrix(-4.38618e-08 1 -0.8667 -0.49883 5.03271 5.81445)" fill="#8E3AF8" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      <rect width="4.69125" height="5.86203" transform="matrix(4.38495e-08 1 0.8667 -0.49883 5.03271 5.81641)" fill="#540BF0" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      <rect opacity="0.19" width="5.8164" height="5.80263" transform="matrix(0.866756 0.498732 -0.866756 0.498732 5.04834 4.68164)" fill="#C09CFC" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
    </svg>;
};
export default TinyCube;